import PasteImageSlatePluginContainer from './PasteImageSlatePluginContainer'
export default PasteImageSlatePluginContainer



// WEBPACK FOOTER //
// ./src/components/PasteImageSlatePlugin/index.js